import { Stack, Text, View } from "@towersystems/roam-common-native";
import { useMeProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { useGlobalSettingsProvider } from "../../utilities/global-settings/hooks";

export const CurrentUserCard = () => {
  const { me } = useMeProvider();
  const { businessName } = useGlobalSettingsProvider();

  return (
    <View>
      <Stack spacing={2} vertical>
        <Text
          style={{ textAlign: "center" }}
          fontWeight="bold"
          variant="heading2"
        >
          {businessName ?? "Unknown Vendor"}
        </Text>
        <Text style={{ textAlign: "center" }} color="subdued">
          {me.identifier ?? "Unknown User"}
        </Text>
      </Stack>
    </View>
  );
};
